import './index.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import TagManager from 'react-gtm-module';
import App from './App';
import { marketing } from './AppSettings';
import TMPostHogProvider from './Analytics/TMPostHogProvider';

if (marketing.gtm_container_id) {
    const tagManagerArgs = {
        gtmId: marketing.gtm_container_id,
    };

    TagManager.initialize(tagManagerArgs);
}

const rootElement = document.getElementById('root');
const root = createRoot(rootElement!);

const app = (
    <React.StrictMode>
        <TMPostHogProvider>
            <App />
        </TMPostHogProvider>
    </React.StrictMode>
);

root.render(app);
